// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 主样式文件 */
.site-layout-header {
    background: #fff;
    padding: 0 24px;
    display: flex;
    align-items: center;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  }
  
  .site-layout-header h1 {
    margin: 0;
    font-size: 20px;
  }
  
  .site-layout-background {
    background: #fff;
    border-radius: 4px;
  }
  
  .logo {
    height: 32px;
    margin: 16px;
    background: rgba(255, 255, 255, 0.3);
    text-align: center;
    color: white;
    line-height: 32px;
    font-weight: bold;
  }
  .fixed-footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    background-color: #f0f0f0;
    padding: 20px;
  }
  /* 其他全局样式 */`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA,UAAU;AACV;IACI,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,2CAA2C;EAC7C;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,aAAa;EACf;EACA,WAAW","sourcesContent":["/* 主样式文件 */\r\n.site-layout-header {\r\n    background: #fff;\r\n    padding: 0 24px;\r\n    display: flex;\r\n    align-items: center;\r\n    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);\r\n  }\r\n  \r\n  .site-layout-header h1 {\r\n    margin: 0;\r\n    font-size: 20px;\r\n  }\r\n  \r\n  .site-layout-background {\r\n    background: #fff;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .logo {\r\n    height: 32px;\r\n    margin: 16px;\r\n    background: rgba(255, 255, 255, 0.3);\r\n    text-align: center;\r\n    color: white;\r\n    line-height: 32px;\r\n    font-weight: bold;\r\n  }\r\n  .fixed-footer {\r\n    position: fixed;\r\n    bottom: 0;\r\n    width: 100%;\r\n    background-color: #f0f0f0;\r\n    padding: 20px;\r\n  }\r\n  /* 其他全局样式 */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
